export const _isDev = process.env.NODE_ENV === 'development'

export const STATUS = {
	ASSIGNED: 'assigned',
	IN_RIVISION: 'in_rivision',
	APPROVED: 'approved',
	RE_PROCESS_EXPERT: 'expert_re_process',
	RE_PROCESS_BANK: 'bank_re_process',
	INVOICED: 'invoiced'
}

export const STATUSES = [
	{ text: 'Asignado', value: STATUS.ASSIGNED, color: '#FF0000' },
	{ text: 'En Revisión', value: STATUS.IN_RIVISION, color: '#FFFF00' },
	{ text: 'Aprobado', value: STATUS.APPROVED, color: '#00C86E' },
	{ text: 'Re-proceso Perito', value: STATUS.RE_PROCESS_EXPERT, color: '#FF6402' },
	{ text: 'Re-proceso Banco', value: STATUS.RE_PROCESS_BANK, color: '#FF6464' },
	{ text: 'Facturado', value: STATUS.INVOICED, color: "#FF00FF" },
]

export const ROLES = {
	ADMIN: 'ADMIN',
	CLIENT: 'CLIENT',
	EXPERT_ADMIN: 'EXPERT_ADMIN',
	EXPERT_CLIENT: 'EXPERT_CLIENT',
}

export const USER_TYPES = {
	INTERNAL: 'INTERNAL',
	EXTERNAL: 'EXTERNAL'
}

export const _firebaseConfig = {
	apiKey: process.env.VUE_APP_FB_API_KEY,
	authDomain: process.env.VUE_APP_FB_AUTH_DOMAIN,
	projectId: process.env.VUE_APP_FB_PROJECT_ID,
	storageBucket: process.env.VUE_APP_FB_STORAGE_BUCKET,
	messagingSenderId: process.env.VUE_APP_FB_MESSAGING_SENDER_ID,
	appId: process.env.VUE_APP_FB_APP_ID,
	measurementId: process.env.VUE_APP_FB_MEASUREMENT_ID,
}

// export const _firebaseConfig = {
//   apiKey: "AIzaSyAVAPuU89LgvU20UMzDStU1nerH2Zb2qXA",
//   authDomain: "vlactest01.firebaseapp.com",
//   databaseURL: "https://vlactest01-default-rtdb.firebaseio.com",
//   projectId: "vlactest01",
//   storageBucket: "vlactest01.appspot.com",
//   messagingSenderId: "259263606119",
//   appId: "1:259263606119:web:25b30451da0386c047d3c2",
//   measurementId: "G-NTRVVK4V0B"
// };
